var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-ai-robot__input-magic" }, [
    _c(
      "div",
      { staticClass: "yxtbiz-ai-robot__input-magic__wrap" },
      [
        _c(
          "yxt-tooltip",
          {
            attrs: {
              content: _vm.$t("biz_ai_switchdisabled"),
              placement: "top",
              disabled: !_vm.isWaitAnswer,
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "yxtbiz-ai-robot__input-magic--common hand",
                class: {
                  "is-selected": _vm.selected === 0,
                  "no-allow opacity6": _vm.isWaitAnswer,
                },
                on: {
                  click: function ($event) {
                    return _vm.changeAskType(0)
                  },
                },
              },
              [
                _c("yxt-svg", {
                  attrs: {
                    "remote-url":
                      _vm.$staticBaseUrl + "ufd/55a3e0/assistent/pc/svg/",
                    width: 16,
                    height: 16,
                    "icon-class":
                      _vm.selected === 0 ? "ai_answer" : "ai_answer_gray",
                  },
                }),
                _c("span", { staticClass: "ml4" }, [
                  _vm._v(
                    _vm._s(_vm.$t("pc_ass_knowledgeanswer" /** 知识问答 */))
                  ),
                ]),
              ],
              1
            ),
          ]
        ),
        _c(
          "yxt-tooltip",
          {
            attrs: {
              content: _vm.$t("biz_ai_switchdisabled"),
              placement: "top",
              disabled: !_vm.isWaitAnswer,
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "yxtbiz-ai-robot__input-magic--common ml12 hand",
                class: {
                  "is-selected": _vm.selected === 1,
                  "no-allow opacity6": _vm.isWaitAnswer,
                },
                on: {
                  click: function ($event) {
                    return _vm.changeAskType(1)
                  },
                },
              },
              [
                _c("yxt-svg", {
                  attrs: {
                    "remote-url":
                      _vm.$staticBaseUrl + "ufd/55a3e0/assistent/pc/svg/",
                    width: 16,
                    height: 16,
                    "icon-class":
                      _vm.selected === 1 ? "ai_instruct" : "ai_instruct_gray",
                  },
                }),
                _c("span", { staticClass: "ml4" }, [
                  _vm._v(_vm._s(_vm.$t("pc_ass_taskinstruct" /** 任务助手 */))),
                ]),
              ],
              1
            ),
          ]
        ),
        _c("div", { staticClass: "flex-1" }),
        _c(
          "yxt-tooltip",
          {
            attrs: {
              content: _vm.$t("biz_ai_switchdisabled"),
              placement: "top",
              disabled: !_vm.isWaitAnswer,
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "yxtbiz-ai-robot__input-magic--common hand",
                class: { "no-allow opacity6": _vm.isWaitAnswer },
                on: { click: _vm.handleOpenTreasure },
              },
              [
                _c("yxt-svg", {
                  attrs: {
                    "remote-url":
                      _vm.$staticBaseUrl + "ufd/55a3e0/assistent/pc/svg/",
                    width: 16,
                    height: 16,
                    "icon-class": "treasure_gray",
                  },
                }),
                _c("span", { staticClass: "ml4" }, [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_lbl_treasure_chest" /** 任务助手 */))
                  ),
                ]),
              ],
              1
            ),
          ]
        ),
        _c(
          "yxt-dropdown",
          {
            ref: "dropRefs",
            attrs: {
              "custom-elm": "",
              loading: _vm.loading,
              placement: "top-start",
              trigger: "click",
            },
            on: {
              "visible-change": _vm.visibleChange,
              command: _vm.handleCommand,
            },
          },
          [
            _c("div", { staticClass: "is-magic-dropdown" }),
            _c(
              "yxt-dropdown-menu",
              {
                staticClass: "yxtbiz-ai-robot__input-dropdown",
                class: {
                  "yxtbiz-ai-robot__input-dropdown--large": _vm.isFullScreen,
                },
                attrs: { slot: "dropdown" },
                slot: "dropdown",
              },
              [
                !_vm.info.length
                  ? _c("yxt-empty", [
                      _c(
                        "div",
                        {
                          staticClass: "yxtbiz-ai-robot__input-dropdown--empty",
                          attrs: { slot: "image" },
                          slot: "image",
                        },
                        [
                          _c("img", {
                            attrs: {
                              src:
                                _vm.$staticBaseUrl +
                                "/ufd/55a3e0/img/ai-empty-app.jpg",
                            },
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "mt12",
                          attrs: { slot: "text" },
                          slot: "text",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm
                                .$t("pc_biz_msg_empty_common_app")
                                .d("暂无常用应用")
                            )
                          ),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm
                                  .$t("pc_biz_msg_empty_common_app1")
                                  .d("可前往百宝箱添加")
                              )
                            ),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._l(_vm.info, function (item) {
                      return _c(
                        "yxt-dropdown-item",
                        { key: item.id, attrs: { command: item } },
                        [
                          _c("yxt-image", {
                            staticClass: "yxtbiz-ai-robot__wrap--img",
                            attrs: {
                              src:
                                item.icon ||
                                _vm.$staticBaseUrl + "ufd/55a3e0/ai-select.png",
                            },
                          }),
                          _c(
                            "span",
                            { staticClass: "text-26 font-size-16 v-mid" },
                            [_vm._v("\n            " + _vm._s(item.appName))]
                          ),
                        ],
                        1
                      )
                    }),
              ],
              2
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }